import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL;
const API_URL = process.env.REACT_APP_API_URL || "https://api.utiliti.ng";


export const settingsService = {
  // Update charges
  updateCharges: async (charges) => {
    try {
      const response = await axios.put(
        `${API_URL}/settings/charges`,
        { charges },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update maintenance mode
  updateMaintenanceMode: async (isEnabled) => {
    try {
      const response = await axios.put(
        `${API_URL}/settings/maintenance-mode`,
        { isEnabled },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update transfer maintenance mode
  updateTransferMaintenanceMode: async (isEnabled) => {
    try {
      const response = await axios.put(
        `${API_URL}/settings/transfer-maintenance-mode`,
        { isEnabled },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update Payscribe threshold
  updatePayscribeThreshold: async (threshold) => {
    try {
      const response = await axios.put(
        `${API_URL}/settings/payscribe-threshold`,
        { threshold },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update SafeHaven threshold
  updateSafeHavenThreshold: async (threshold) => {
    try {
      const response = await axios.put(
        `${API_URL}/settings/safehaven-threshold`,
        { threshold },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update transfer fee
  updateTransferFee: async (fee) => {
    try {
      const response = await axios.put(
        `${API_URL}/settings/transfer-fee`,
        { fee },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update electronic levy
  updateElectronicLevy: async (levy) => {
    try {
      const response = await axios.put(
        `${API_URL}/settings/electronic-levy`,
        { levy },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update free transfer times (daily and/or monthly)
  updateFreeTransferTimes: async (times, timesPerMonth) => {
    try {
      const body = {};
      if (times !== undefined) {
        body.times = times;
      }
      if (timesPerMonth !== undefined) {
        body.timesPerMonth = timesPerMonth;
      }
      const response = await axios.put(
        `${API_URL}/settings/free-transfer-times`,
        body,
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all settings
  getSettings: async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/admin/settings`,
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all admin settings (push notifications, loyalty points)
  getAdminSettings: async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/admin/settings`,
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update admin settings (push notifications, loyalty points)
  updateAdminSettings: async (updates) => {
    try {
      // Handle ATM card settings separately
      if (updates.atmCard) {
        console.log('Saving ATM card settings:', updates.atmCard);
        console.log('Auth headers:', settingsService.getAuthHeaders());

        const atmCardResponse = await axios.put(
          `${API_URL}/api/atm-card/admin/settings`,
          {
            fees: {
              deliveryFee: updates.atmCard.deliveryFee,
              cardCollectionFee: updates.atmCard.cardCollectionFee,
            },
            system: {
              isCardRequestEnabled: updates.atmCard.enabled,
              enableDeliveryFeeCashback: updates.atmCard.cashbackEnabled,
              cashbackPercentage: updates.atmCard.cashbackPercentage,
            }
          },
          { headers: settingsService.getAuthHeaders() }
        );

        // Remove ATM card from updates to avoid conflicts
        const { atmCard, ...otherUpdates } = updates;

        // If there are other updates, send them to the general admin settings endpoint
        if (Object.keys(otherUpdates).length > 0) {
          const generalResponse = await axios.post(
            `${API_URL}/api/admin/settings`,
            otherUpdates,
            { headers: settingsService.getAuthHeaders() }
          );
          return { ...atmCardResponse.data, ...generalResponse.data };
        }

        console.log('ATM card settings saved successfully:', atmCardResponse.data);
        return atmCardResponse.data;
      }

      // For non-ATM card settings, use the general endpoint
      const response = await axios.post(
        `${API_URL}/api/admin/settings`,
        updates,
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error saving admin settings:', error);
      console.error('Error response:', error.response?.data);
      throw error.response?.data || error.message;
    }
  },

  // Update KYC settings
  updateKycSettings: async (kycDailyLimit, kycMonthlyLimit, kycAutoSuspend) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/admin/settings`,
        {
          kycDailyLimit,
          kycMonthlyLimit,
          kycAutoSuspend
        },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getAuthHeaders: () => {
    const token = localStorage.getItem('token');
    // Remove "Bearer " prefix if it exists
    const cleanToken = token ? token.replace(/^Bearer\s+/i, '') : '';
    return {
      'x-auth-token': cleanToken,
      'Accept': 'application/json',
    };
  },

  updateTransferFeeTier1: async (fee) => {
    try {
      const response = await axios.put(
        `${API_URL}/settings/transfer-fee-tier1`,
        { fee },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateTransferFeeTier2: async (fee) => {
    try {
      const response = await axios.put(
        `${API_URL}/settings/transfer-fee-tier2`,
        { fee },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get ATM card settings
  getAtmCardSettings: async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/atm-card/admin/settings`,
        { headers: settingsService.getAuthHeaders() }
      );
      console.log(response.data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  updateTransferFeeTier3: async (fee) => {
    try {
      const response = await axios.put(
        `${API_URL}/settings/transfer-fee-tier3`,
        { fee },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Test email server connection
  testEmailConnection: async (email) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/admin/email/test`,
        { email },
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get system logs
  getSystemLogs: async (type = 'access', lines = 100) => {
    try {
      const response = await axios.get(
        `${API_URL}/api/admin/settings/logs?type=${type}&lines=${lines}`,
        { headers: settingsService.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};